import React from 'react'
import { ReactFC } from 'types'
import { PostEventData } from 'posts/posts.types'
import { FormattedMessage, FormattedTime } from 'react-intl'
import { isValidDate } from 'posts/isValidDate'
import { SmallFontBlock } from './SmallFontBlock'

export const EventTime: ReactFC<{ event: PostEventData }> = ({ event }) => {
    return (
        <div style={{ marginTop: 20 }}>
            <TimeLine prefix={<FormattedMessage id="event.startsPrefix" />} time={event.localStartTime} />
            <TimeLine prefix={<FormattedMessage id="event.endsPrefix" />} time={event.localEndTime} />
        </div>
    )
}
export const TimeLine: ReactFC<{ prefix: React.ReactNode, time: Date }> = ({ prefix, time }) => {
    if (!isValidDate(time)) {
        return null
    }
    return (
        <SmallFontBlock>
            <span>{prefix}</span>&nbsp;<FormattedTime value={time} />
        </SmallFontBlock>
    )
}
